import { FC } from "react";
import { Button, ButtonVariant, Modal } from "shared/components";
import { Invitee } from "shared/types";
import { InfoCircle } from "untitledui-js-base";

type Props = {
  opened: boolean;
  onClose: () => void;
  onContinue: () => void;
  applicants: Invitee[];
};

export const DecisionConfirmationModal: FC<Props> = ({
  opened,
  onClose,
  onContinue,
  applicants
}) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      panelClassName="max-w-[366px] items-center flex flex-col p-6 shadow-lg border border-alpha-100"
    >
      <div className="mb-4">
        <InfoCircle className="text-primary-500" size="32" />
      </div>
      <p className="mb-4 text-center text-xl font-bold text-content-1000">
        Are you sure you want to make a decision now?
      </p>
      <p className="mb-4 text-center text-sm text-content-1000">
        Some invited applicants have not started their applications yet:
      </p>
      <div className="mb-8 flex items-center rounded-lg bg-alpha-40 p-4 w-full">
        <ul className="list-disc pl-4">
          {applicants.map((applicant, index) => (
            <li key={index} className="text-sm font-medium text-content-1000">
              {applicant.email}
            </li>
          ))}
        </ul>
      </div>
      <div className="flex w-full gap-2.5">
        <div className="flex-grow">
          <Button className="w-full" onClick={onClose}>
            Cancel
          </Button>
        </div>
        <div className="flex-grow">
          <Button
            className="w-full"
            variant={ButtonVariant.PRIMARY}
            onClick={onContinue}
          >
            Continue
          </Button>
        </div>
      </div>
    </Modal>
  );
};
